import React, { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ImagePage from './pages/ImagePage';
import VideoPage from './pages/VideoPage';

const CompressImagePage  = lazy(() => import('./pages/tools/CompressImagePage'));
const ResizeImagePage    = lazy(() => import('./pages/tools/ResizeImagePage'));
const CropImagePage      = lazy(() => import('./pages/tools/CropImagePage'));
const ConvertImagePage   = lazy(() => import('./pages/tools/ConvertImagePage'));
const WatermarkImagePage = lazy(() => import('./pages/tools/WatermarkImagePage'));
const ImageEffectsPage   = lazy(() => import('./pages/tools/ImageEffectsPage'));
const HubPage            = lazy(() => import('./pages/tools/HubPage'));
const LandingPage        = lazy(() => import('./pages/LandingPage'));

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <Router>
        <div className="App">
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/image" element={<ImagePage theme={theme} setTheme={setTheme} />} />
          <Route path="/video" element={<VideoPage theme={theme} setTheme={setTheme} />} />
          <Route path="/tools"                  element={<HubPage />} />
          <Route path="/tools/compress-image"  element={<CompressImagePage />} />
          <Route path="/tools/resize-image"    element={<ResizeImagePage />} />
          <Route path="/tools/crop-image"      element={<CropImagePage />} />
          <Route path="/tools/convert-image"   element={<ConvertImagePage />} />
          <Route path="/tools/add-watermark"   element={<WatermarkImagePage />} />
          <Route path="/tools/image-effects"   element={<ImageEffectsPage />} />
        </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;

